import { ServiceDataFields } from './service-data-fields.enum';

export const galleriFieldSet = [
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.PatientGender,
  ServiceDataFields.PregnancyInformation,
  ServiceDataFields.PregnancyStatus,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.CurrentlyDiagnosedWithCancer,
  ServiceDataFields.CancerSurvivor,
  ServiceDataFields.BoneMarrowTransplant,
  ServiceDataFields.SolidOrganTransplant,
  ServiceDataFields.CancerSuspicion,
];
